import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import { useContext, useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { getNullLogger, getSubscriptionManager, initializeGlobalObject } from '@uniformdev/common';
import { UniformContext } from '@uniformdev/react';
import { TrackerContext } from './TrackerContext';
import { useScripts } from './useScripts';
import { QUEUE_ENTRY_TYPE_TRACKER, getCookieValueFromVisit, getCurrentVisit } from '@uniformdev/tracking';
import { CONTEXT_SOURCE_SITECORE } from '@uniformdev/tracking';
import { UniformCookieNames, SitecoreCookieNames, getCookieValueFromVisitor } from '@uniformdev/tracking';
import { getDispatchersForGaDestinations } from './ga';
import { getDispatchersForXdbDestinations } from './xdb';
import { getDispatchersForOracleDmpDestinations } from './oracleDmp';
import { getDefaultDecaySettings, getSitecoreTracker } from '@uniformdev/tracking';
/**
 * Merge tracking scripts from tracking data and props, with
 * values from props having priority.
 * @param trackingData
 * @param props
 */
function getTrackerScripts(trackingData, props) {
  var _a, _b;
  var append = function append(source, target) {
    if (!source) {
      return;
    }
    Object.keys(source).forEach(function (id) {
      target[id] = source[id];
    });
  };
  var scripts = {};
  append((_b = (_a = trackingData === null || trackingData === void 0 ? void 0 : trackingData.tracking) === null || _a === void 0 ? void 0 : _a.settings) === null || _b === void 0 ? void 0 : _b.scripts, scripts);
  append(props === null || props === void 0 ? void 0 : props.scripts, scripts);
  if (!scripts['optimize']) {
    scripts['optimize'] = '/uniform.optimize.min.js';
  }
  return scripts;
}
/**
 * Merge tracker cookie types from tracking data and props,
 * with values from props having priority.
 * @param trackingData
 * @param props
 */
function getTrackerCookieTypes(trackingData, props) {
  var _a, _b;
  var append = function append(source, target) {
    if (!source) {
      return;
    }
    source.forEach(function (value) {
      if (target.indexOf(value) == -1) {
        target.push(value);
      }
    });
  };
  var cookieTypes = [];
  append((_b = (_a = trackingData === null || trackingData === void 0 ? void 0 : trackingData.tracking) === null || _a === void 0 ? void 0 : _a.settings) === null || _b === void 0 ? void 0 : _b.cookies, cookieTypes);
  append(props === null || props === void 0 ? void 0 : props.cookies, cookieTypes);
  return cookieTypes;
}
/**
 * Certain tracker data can be configured to be set in cookies.
 * This function adds subscriptions to the tracker to set those
 * cookies.
 * @param cookieTypes
 * @param setCookie
 * @param removeCookie
 * @param trackerSubs
 */
function addSubscriptionsForTrackerCookies(cookieTypes, setCookie, removeCookie, trackerSubs, logger) {
  if (!cookieTypes || cookieTypes.length == 0) {
    return;
  }
  trackerSubs.subscribe("visit-created", function (e) {
    var _a, _b, _c, _d;
    if (cookieTypes.indexOf('visitCount') > -1) {
      var count = (_b = (_a = e.visitor) === null || _a === void 0 ? void 0 : _a.visits.length) !== null && _b !== void 0 ? _b : 0;
      if (count == 0) {
        logger.debug("useSitecoreTracker - Visit created event was triggered. No visits are assigned to the visitor, so removing the cookie for visit count.", {
          cookie: UniformCookieNames.VisitCount,
          event: e
        });
        removeCookie(UniformCookieNames.VisitCount);
      } else {
        logger.debug("useSitecoreTracker - Visit created event was triggered. Updating the cookie for visit count.", {
          cookie: UniformCookieNames.VisitCount,
          count: (_c = e.visitor) === null || _c === void 0 ? void 0 : _c.visits.length
        });
        setCookie(UniformCookieNames.VisitCount, (_d = e.visitor) === null || _d === void 0 ? void 0 : _d.visits.length);
      }
    }
    //
    //Remove visit-specific cookies.
    if (cookieTypes.indexOf('goals') > -1) {
      logger.debug("useSitecoreTracker - Visit created event was triggered. Resetting the cookie for goal tracking.", {
        cookie: SitecoreCookieNames.Goals
      });
      removeCookie(SitecoreCookieNames.Goals);
    }
  });
  trackerSubs.subscribe("visit-updated", function (e) {
    if (e.visitor) {
      var visit = getCurrentVisit(e.visitor);
      if (visit) {
        if (e.changes.get(visit.id)) {
          if (cookieTypes.indexOf('goals') > -1) {
            var goals = getCookieValueFromVisit('goals', visit);
            logger.debug("useSitecoreTracker - Visit updated event was triggered. Updating the cookie for goal tracking.", {
              cookie: SitecoreCookieNames.Goals,
              visit: visit
            });
            if (!goals) {
              removeCookie(SitecoreCookieNames.Goals);
            } else {
              setCookie(SitecoreCookieNames.Goals, goals);
            }
          }
          if (cookieTypes.indexOf('campaign') > -1) {
            var campaignId = getCookieValueFromVisit('campaign', visit);
            logger.debug("useSitecoreTracker - Visit updated event was triggered. Updating the cookie for campaign tracking.", {
              cookie: SitecoreCookieNames.Campaign,
              visit: visit
            });
            if (!campaignId) {
              removeCookie(SitecoreCookieNames.Campaign);
            } else {
              setCookie(SitecoreCookieNames.Campaign, campaignId);
            }
          }
        }
      }
    }
  });
  trackerSubs.subscribe("visitor-updated", function (e) {
    if (e.visitor) {
      if (cookieTypes.indexOf('patterns') > -1) {
        var patterns = getCookieValueFromVisitor('patterns', e.visitor);
        logger.debug("useSitecoreTracker - Visitor updated event was triggered. Updating the cookie for pattern match tracking.", {
          cookie: SitecoreCookieNames.PatternMatches,
          visitor: e.visitor
        });
        if (!patterns) {
          removeCookie(SitecoreCookieNames.PatternMatches);
        } else {
          setCookie(SitecoreCookieNames.PatternMatches, patterns);
        }
      }
      if (cookieTypes.indexOf('profiles') > -1) {
        var profiles = getCookieValueFromVisitor('profiles', e.visitor);
        logger.debug("useSitecoreTracker - Visitor updated event was triggered. Updating the cookie for profile score tracking.", {
          cookie: SitecoreCookieNames.ProfileScores,
          visitor: e.visitor
        });
        if (!profiles) {
          removeCookie(SitecoreCookieNames.ProfileScores);
        } else {
          setCookie(SitecoreCookieNames.ProfileScores, profiles);
        }
      }
    }
  });
}
/**
 * Returns a map of destinations from tracking data, grouped by type.
 * @param trackingData
 * @param logger
 */
function getDestinationMapFromTrackingData(trackingData, logger) {
  var _a, _b, _c;
  var map = new Map();
  var tracking = trackingData === null || trackingData === void 0 ? void 0 : trackingData.tracking;
  if (!tracking) {
    tracking = (_b = (_a = trackingData === null || trackingData === void 0 ? void 0 : trackingData.sitecore) === null || _a === void 0 ? void 0 : _a.context) === null || _b === void 0 ? void 0 : _b.tracking;
  }
  if (!tracking) {
    logger.warn('No tracking data resolved');
  }
  var allDestinations = tracking.destinations;
  if ((_c = allDestinations === null || allDestinations === void 0 ? void 0 : allDestinations.length) !== null && _c !== void 0 ? _c : 0 > 0) {
    allDestinations.forEach(function (destination) {
      var _a;
      var type = destination.type;
      var destinations = (_a = map.get(type)) !== null && _a !== void 0 ? _a : [];
      if (destination.configId && destinations.some(function (d) {
        return d.configId == destination.configId;
      })) {
        logger.debug("useSitecoreTracker - Destination is included in the tracking data multiple times. It will not be added to the destination map more than once.", destination);
        return;
      }
      destinations.push(destination);
      map.set(type, destinations);
    });
  }
  return map;
}
/**
 * Adds elements from the source array to the target array,
 * provided the element is not already a member of the target.
 * @param source
 * @param target
 */
function addSourceToTarget(source, target) {
  if (source.length > 0) {
    source.forEach(function (member) {
      if (target.indexOf(member) == -1) {
        target.push(member);
      }
    });
  }
}
;
/**
 * When dispatchers are configured in Sitecore, they
 * are exposed in tracking data as destinations. This
 * function controlls the process responsible for
 * converting these destinations into dispatchers.
 * @param trackingData
 * @param logger
 */
function getDispatchersFromTrackingData(trackingData, logger) {
  var dispatchers = [];
  var map = getDestinationMapFromTrackingData(trackingData, logger);
  var keys = Array.from(map.keys());
  keys.forEach(function (key) {
    var _a, _b, _c, _d;
    var destinations = (_a = map.get(key)) !== null && _a !== void 0 ? _a : [];
    if (destinations.length == 0) {
      return;
    }
    switch (key) {
      case "ga":
        var gaDispatchers = (_b = getDispatchersForGaDestinations(destinations, logger)) !== null && _b !== void 0 ? _b : [];
        if (gaDispatchers.length > 0) {
          logger.debug("useSitecoreTracker - GA dispatchers were registered.", gaDispatchers);
          addSourceToTarget(gaDispatchers, dispatchers);
        }
        return;
      case "oracleDmp":
        var oracleDmpDispatchers = (_c = getDispatchersForOracleDmpDestinations(destinations, logger)) !== null && _c !== void 0 ? _c : [];
        if (oracleDmpDispatchers.length > 0) {
          logger.debug("useSitecoreTracker - Oracle DMP dispatchers were registered.", oracleDmpDispatchers);
          addSourceToTarget(oracleDmpDispatchers, dispatchers);
        }
        return;
      case "xdb":
        var xdbDispatchers = (_d = getDispatchersForXdbDestinations(destinations, logger)) !== null && _d !== void 0 ? _d : [];
        if (xdbDispatchers.length > 0) {
          logger.debug("useSitecoreTracker - xDB dispatchers were registered.", xdbDispatchers);
          addSourceToTarget(xdbDispatchers, dispatchers);
        }
        return;
      default:
        logger.error("useSitecoreTracker - The specified destination type is not supported.", {
          type: key,
          destinations: destinations.length
        });
        return;
    }
  });
  return dispatchers;
}
/**
 * When dispatchers are configured by a developer, they
 * are exposed in hook's props as destinations. This
 * function controls the process responsible for
 * converting these destinations into dispatchers.
 * @param props
 * @param logger
 */
function getDispatchersFromProps(props, logger) {
  var dispatchers = [];
  if (props.ga) {
    addSourceToTarget(getDispatchersForGaDestinations([props.ga], logger), dispatchers);
  }
  if (props.oracleDmp) {
    addSourceToTarget(getDispatchersForOracleDmpDestinations([props.oracleDmp], logger), dispatchers);
  }
  if (props.xdb) {
    addSourceToTarget(getDispatchersForXdbDestinations([props.xdb], logger), dispatchers);
  }
  return dispatchers;
}
/**
 * Get dispatchers from tracking data and props.
 * @param trackingData
 * @param props
 * @param logger
 */
function getDispatchers(trackingData, props, logger) {
  //
  //
  var fromProps = getDispatchersFromProps(props, logger);
  if (fromProps.length > 0) {
    logger.debug("useSitecoreTracker - Dispatchers retrieved from destinations set on props.", fromProps);
  }
  //
  //
  var fromTrackingData = getDispatchersFromTrackingData(trackingData, logger);
  if (fromTrackingData.length > 0) {
    logger.debug("useSitecoreTracker - Dispatchers retrieved from tracking data.", fromTrackingData);
  }
  //
  //
  return fromProps.concat(fromTrackingData);
}
function isReadyToRunHook(trackingData, logger) {
  if (trackingData === null || trackingData === void 0 ? void 0 : trackingData.tracking) {
    return true;
  }
  logger.debug("Tracking data is undefined or tracking data is defined but there is no tracking object available. The tracker cannot be loaded until this object is available.", {
    trackingData: trackingData
  });
  return false;
}
export function useSitecoreTracker(trackingData, props) {
  var _a;
  var logger = (_a = props === null || props === void 0 ? void 0 : props.logger) !== null && _a !== void 0 ? _a : getNullLogger();
  var uniformContext = useContext(UniformContext);
  var trackerContext = useContext(TrackerContext);
  var _useCookies = useCookies([]),
    _useCookies2 = _slicedToArray(_useCookies, 3),
    cookies = _useCookies2[0],
    setCookie = _useCookies2[1],
    removeCookie = _useCookies2[2];
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    tracker = _useState2[0],
    setTracker = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    scriptsLoaded = _useState4[0],
    setScriptsLoaded = _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    trackerScripts = _useState6[0],
    setTrackerScripts = _useState6[1];
  useEffect(function () {
    //
    //This hook usually is passed the Sitecore context, and this context
    //may change as the page is loaded. As a result, this hook shouldn't
    //run until it's clear that enough context data is available to run.
    if (!isReadyToRunHook(trackingData, logger)) {
      return;
    }
    var scripts = getTrackerScripts(trackingData, props);
    setTrackerScripts(scripts);
  }, [trackingData]);
  useScripts(trackerScripts, function () {
    if (scriptsLoaded == true) {
      return;
    }
    initializeGlobalObject();
    if (Object.keys(trackerScripts).length == 0) {
      logger.info("useSitecoreTracker - No scripts were specified to be loaded.");
    } else {
      logger.info("useSitecoreTracker - Scripts are loaded.", trackerScripts);
    }
    setScriptsLoaded(true);
  });
  useEffect(function () {
    var _a, _b, _c, _d, _e;
    if (scriptsLoaded != true) {
      return;
    }
    //
    //Add subscriptions to tracker.
    var trackerSubs = getSubscriptionManager();
    if (props === null || props === void 0 ? void 0 : props.subscriptions) {
      logger.debug("useSitecoreTracker - Adding subscribers from props to the tracker.");
      props.subscriptions(trackerSubs.subscribe);
    }
    //
    //
    var trackerCookies = getTrackerCookieTypes(trackingData, props);
    addSubscriptionsForTrackerCookies(trackerCookies, setCookie, removeCookie, trackerSubs, logger);
    //
    //Add subscription to publish tracker events to the context.
    var unsubscribes = [];
    if (!uniformContext.subscriptions) {
      uniformContext.subscriptions = getSubscriptionManager();
    }
    var contextSubs = uniformContext.subscriptions;
    if (contextSubs) {
      logger.debug("useSitecoreTracker - Adding subscriber to tracker to publish tracker events to context.");
      var unsubscribe = trackerSubs.subscribe(undefined, function (e) {
        contextSubs.publish(e);
      });
      if (unsubscribe) {
        unsubscribes.push(unsubscribe);
      }
    }
    //
    //
    var dispatchers = getDispatchers(trackingData, props !== null && props !== void 0 ? props : {}, logger);
    if (dispatchers.length == 0) {
      logger.debug("useSitecoreTracker - No dispatchers were found.");
    }
    //
    //
    var contextReaders = new Map();
    if (props === null || props === void 0 ? void 0 : props.contextReaders) {
      contextReaders.set(CONTEXT_SOURCE_SITECORE, props.contextReaders);
    }
    //
    //
    var args = {
      decay: (_a = props === null || props === void 0 ? void 0 : props.decay) !== null && _a !== void 0 ? _a : getDefaultDecaySettings(),
      dispatchers: dispatchers,
      logger: logger,
      sessionTimeout: (_b = props === null || props === void 0 ? void 0 : props.sessionTimeout) !== null && _b !== void 0 ? _b : 20,
      type: (_c = props === null || props === void 0 ? void 0 : props.type) !== null && _c !== void 0 ? _c : 'default',
      storage: (_d = props === null || props === void 0 ? void 0 : props.storage) !== null && _d !== void 0 ? _d : 'default',
      subscriptions: trackerSubs,
      contextReaders: contextReaders
    };
    //
    //Get the tracker
    logger.debug('useSitecoreTracker - Initializing the tracker.', {
      settings: args
    });
    var scTracker = getSitecoreTracker(args, logger);
    if (!scTracker) {
      logger.error('useSitecoreTracker - No tracker was resolved.');
      return;
    }
    setTracker(scTracker);
    logger.debug('useSitecoreTracker - Tracker was resolved.', scTracker);
    //
    //Update the tracker context.
    logger.debug('useSitecoreTracker - Updating the tracker context.', trackerContext);
    trackerContext.tracker = scTracker;
    if (trackerContext.subscriptions) {
      logger.debug('useSitecoreTracker - Notifying tracker context subscribers that the tracker is ready.', trackerContext);
      trackerContext.subscriptions.publish({
        type: "tracker-set",
        when: new Date(),
        tracker: scTracker
      });
    }
    //
    //Get the tracker settings.
    var visitorId = cookies[UniformCookieNames.VisitorId];
    if (visitorId) {
      logger.debug('useSitecoreTracker - Found visitor id in cookie.', {
        cookie: UniformCookieNames.VisitorId,
        value: visitorId
      });
    }
    var trackingSettings = {
      visitorId: visitorId,
      createVisitor: true
    };
    //
    //Use the tracker.
    if ((props === null || props === void 0 ? void 0 : props.clientSideRouting) == true) {
      logger.debug('useSitecoreTracker - Client-side routing is enabled, so the hook will only initialize the tracker. ' + 'The tracker must be called in the application, when the application determines the route has changed.');
      var results = scTracker.initialize(trackingSettings);
      logger.debug('useSitecoreTracker - Received tracking results from tracker initialization.', results);
      visitorId = updateCookie(visitorId, results);
    } else {
      logger.debug('useSitecoreTracker - Client-side routing is disabled, so track using tracking data.', {
        props: props,
        trackingData: trackingData,
        trackingSettings: trackingSettings
      });
      var _results = scTracker.track('sitecore', trackingData, trackingSettings);
      logger.debug('useSitecoreTracker - Received tracking results from tracking with tracking data.', {
        visitorId: visitorId,
        results: _results
      });
      visitorId = updateCookie(visitorId, _results);
    }
    trackerContext.visitorId = visitorId;
    //
    //
    if (props === null || props === void 0 ? void 0 : props.onInitialized) {
      props.onInitialized();
    }
    //
    //Components can use the global queue to capture
    //tracker events even if the tracker is not yet
    //initialized. Now that the tracker is being 
    //initialized, it is time to handle those events.
    var queue = (_e = window.uniform) === null || _e === void 0 ? void 0 : _e.queue;
    if (queue) {
      var handleEntry = function handleEntry(entry) {
        var _a;
        if (entry) {
          var _tracker = (_a = window.uniform) === null || _a === void 0 ? void 0 : _a.tracker;
          if (_tracker) {
            var settings = {
              visitorId: visitorId
            };
            logger.debug('useSitecoreTracker - Will track using global queue entry data.', {
              entry: entry,
              settings: settings
            });
            var _results2 = _tracker.event(entry.type, entry.e, settings);
            logger.debug('useSitecoreTracker - Received tracking results from tracking with global queue entry data.', _results2);
            visitorId = updateCookie(visitorId, _results2);
          }
        }
      };
      //
      //Process entries already in the global queue.
      while (queue.count(QUEUE_ENTRY_TYPE_TRACKER) > 0) {
        var entry = queue.get(QUEUE_ENTRY_TYPE_TRACKER);
        handleEntry(entry);
      }
      //
      //Subscribe to the global queue.
      var _unsubscribe = queue.subscribe(QUEUE_ENTRY_TYPE_TRACKER, function (e) {
        var entry = e.entry;
        handleEntry(entry);
      });
      if (_unsubscribe) {
        unsubscribes.push(_unsubscribe);
      }
    } else {
      logger.debug('useSitecoreTracker - No global queue is available, so no queue processing will run.');
    }
    //
    //
    return function cleanup() {
      logger.debug('useSitecoreTracker - Removing subscriber from context that publishes tracker events to context.');
      unsubscribes.forEach(function (unsub) {
        return unsub();
      });
    };
  }, [scriptsLoaded]);
  function updateCookie(visitorId, results) {
    var _a, _b;
    var newId = (_b = (_a = results.visitor) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : visitorId;
    if (visitorId != newId) {
      logger.debug('useSitecoreTracker - Updating the visitor id cookie.', {
        old: visitorId,
        new: newId
      });
      setCookie(UniformCookieNames.VisitorId, newId, {
        path: "/"
      });
    }
    return newId;
  }
  return tracker;
}